import { Dice6Icon } from './Dice6Icon';

/**
 * author: Yasmina Lembachar
 * id 015F173B-CA59-4125-8F19-925ED108BE07
 * name dice-6
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dice-6.svg
 * tags
 * - Gaming / RPG 
 */
export const Die6Icon = Dice6Icon;
export default Die6Icon